export default "__VITE_ASSET__Cllsq3J3__"